import SectionErrorRoute from 'garaje/utils/section-error-route';

export default class ScheduleErrorRoute extends SectionErrorRoute {
  section = 'schedule';
}
